import { render, staticRenderFns } from "./ScoreMark.vue?vue&type=template&id=ca9493a0&scoped=true&"
import script from "./ScoreMark.vue?vue&type=script&lang=js&"
export * from "./ScoreMark.vue?vue&type=script&lang=js&"
import style0 from "./ScoreMark.vue?vue&type=style&index=0&id=ca9493a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9493a0",
  null
  
)

export default component.exports